import cx from 'classnames';
import { CSSProperties, useState } from 'react';
import {
  MultiSelectCheckbox,
  MultiSelectOption,
} from '../../../MultiSelectCheckbox/MultiSelectCheckbox';
import FormField from '../../../form-field/FormField';
import filterPanelStyles from '../../FilterPanel.module.scss';
import { useFilterPanelContext } from '../../context/FilterPanelContext';
import { FilterField } from '../../types';

interface IProps {
  field: FilterField;
  style?: CSSProperties;
  dropdownClassName?: string;
}

const MultiSelectField = ({ field, style, dropdownClassName }: IProps) => {
  const { values, setValues } = useFilterPanelContext();

  const [openMultiSelectKey, setOpenMultiSelectKey] = useState<string | null>(
    null
  );

  const rawOptions = Array.isArray(field?.options) ? field.options : [];

  const uniqueOptions: MultiSelectOption[] = Array.from(
    new Map(
      rawOptions?.map((opt: any) => [
        opt?.value,
        { id: opt?.value, label: opt?.label },
      ])
    ).values()
  );

  const rawMainOptions = Array.isArray(field?.mainOptions)
    ? field.mainOptions
    : [];

  const uniqueMainOptions: MultiSelectOption[] = Array.from(
    new Map(
      rawMainOptions?.map((opt: any) => [
        opt?.value,
        { id: opt?.value, label: opt?.label },
      ])
    ).values()
  );

  return (
    <div
      key={field.key}
      className={cx(filterPanelStyles.filterItem, field.className)}
      tabIndex={0}
      style={style}
    >
      <FormField label={field.label}>
        <MultiSelectCheckbox
          dropdownClassName={field.dropdownClassName ?? ''}
          options={uniqueOptions}
          mainOptions={uniqueMainOptions}
          value={
            Array.isArray(values?.[field.key])
              ? (values?.[field.key] as string[])
              : values?.[field.key]
              ? [String(values?.[field.key])]
              : []
          }
          onChange={(ids) => {
            {
            /* prettier-ignore */
            /*@ts-ignore */}
            setValues({ ...values, [field.key]: ids });
          }}
          allLabel={field.selectAllPlaceholder ?? 'Все элементы'}
          isUseInput={field.isUseInput ?? true}
          placeholder="Выбрать"
          showSearch={uniqueOptions.length > 10}
          autoFocus={openMultiSelectKey === field.key}
          onOpen={() => setOpenMultiSelectKey(field.key)}
          onClose={() => setOpenMultiSelectKey(null)}
          className={filterPanelStyles.filterItemField}
          disabled={field.disabled}
        />
      </FormField>
    </div>
  );
};

export default MultiSelectField;
